import { useSelector, useDispatch } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { setErrorModal } from "../../Store/Reducers/errorReducer";
import { MdOutlineErrorOutline } from "react-icons/md";
import { useEffect } from "react";
import $ from "jquery"

const ErrorModal = () => {
  const dispatch = useDispatch();
  const { isErrorModalVisible, errorMessage, errorType } = useSelector(state => state.error);

  const closeModal = () => {
    if (errorType === "kyc_error" && $(document.querySelectorAll('.kyc-number')?.length)) {
      setTimeout(() => {
        $(document.querySelectorAll('.kyc-number')[0]).focus();
      }, 200);
    }
    dispatch(setErrorModal({ show: false, message: "", errorType: "" }))
  }

  useEffect(() => {
    if (isErrorModalVisible) {
      setTimeout(() => {
        closeModal();
      }, 5000);
    }
  }, [isErrorModalVisible])

  return (
    <Modal
      show={isErrorModalVisible}
      onHide={closeModal}
      centered
      scrollable
    >
      <Modal.Body>
        <div className="d-flex gap-3 align-items-start">
          <div className="d-flex gap-2 align-items-center">
            <MdOutlineErrorOutline color="#DC3545" size={30} />
          </div>
          <div className="text-danger mb-0" style={{ fontWeight: "500" }} >{errorMessage}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end">
          <Button variant="secondary" onClick={closeModal}>
            Close
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;
